import { N20, N300 } from '@atlaskit/theme/colors';
import React from 'react';
import { CartesianGrid, Legend, Line, LineChart as LineChartLib, Tooltip, XAxis, YAxis } from 'recharts';
import LineChartLegend from "./LineChart.legend";
export const DEFAULT_WIDTH = 990;
export const DEFAULT_HEIGHT = 300;

const LineChart = props => /*#__PURE__*/React.createElement(LineChartLib, {
  width: props.width || DEFAULT_WIDTH,
  height: props.height || DEFAULT_HEIGHT,
  data: props.data,
  margin: {
    left: -15
  }
}, /*#__PURE__*/React.createElement(CartesianGrid, {
  vertical: false,
  stroke: N20
}), /*#__PURE__*/React.createElement(XAxis, {
  dataKey: "xLabel",
  axisLine: false,
  tickLine: false,
  padding: {
    left: 30,
    right: 30
  },
  tickFormatter: props.xLabelFormat,
  tick: {
    stroke: N300,
    fontSize: 11,
    fontWeight: 300
  }
}), /*#__PURE__*/React.createElement(YAxis, {
  axisLine: false,
  tickLine: false,
  tickFormatter: props.yLabelFormat,
  tick: {
    stroke: N300,
    fontSize: 11,
    fontWeight: 300
  }
}), /*#__PURE__*/React.createElement(Legend, {
  wrapperStyle: {
    display: 'flex'
  },
  content: ({
    payload
  }) => /*#__PURE__*/React.createElement(LineChartLegend, {
    payload: payload,
    legendDirection: props.legendDirection
  })
}), props.tooltip && /*#__PURE__*/React.createElement(Tooltip, {
  content: props.tooltip
}), props.lines.map(line => /*#__PURE__*/React.createElement(Line, {
  key: line.color,
  type: "monotone",
  dataKey: line.dataKey,
  legend: line.legend,
  name: line.legend,
  stroke: line.color,
  dot: false,
  strokeWidth: 1.5
})));

export default LineChart;